import { PeopleSearchProfile } from "../../types/peopleSearch.ts";

type PeopleSearchRootState = {
  peopleSearch?: {
    workers?: PeopleSearchProfile[];
  };
};

export const selectPeopleSearchState = (state: PeopleSearchRootState) =>
  state.peopleSearch ?? { workers: [] };

export const selectPeopleSearchWorkers = (state: PeopleSearchRootState) =>
  selectPeopleSearchState(state).workers ?? [];

